<div class="search-container">
  <div class="inputs">
    <form [formGroup]="form" class="form-search">
      <mat-form-field class="search-field">
        <mat-label>Buscar solicitações</mat-label>
        <input
          matInput
          [formControl]="searchControl"
          placeholder="Digite para buscar..."
        />
        @if (loadingService.input$ | async) {
          <mat-icon matSuffix>
            <mat-spinner diameter="22"></mat-spinner>
          </mat-icon>
        } @else {
          <ng-container matSuffix>
            @if (searchControl.value) {
              <button
                mat-icon-button
                (click)="clearText()"
                [attr.aria-label]="'Limpar texto'"
              >
                <mat-icon>close</mat-icon>
              </button>
            } @else {
              <mat-icon>search</mat-icon>
            }
          </ng-container>
        }
      </mat-form-field>

      <mat-form-field class="date-form">
        <mat-label>Escolha uma data</mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
          <input
            matStartDate
            [formControl]="range.controls.start"
            placeholder="Data inicial"
          />
          <input
            matEndDate
            [formControl]="range.controls.end"
            placeholder="Data final"
          />
        </mat-date-range-input>
        <mat-hint>DD/MM/AAAA – DD/MM/AAAA</mat-hint>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <mat-checkbox [formControl]="onlyMineControl" class="only-mine-checkbox">
        Minhas solicitações
      </mat-checkbox>
    </form>
  </div>
</div>
